import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  tabs: {
    boxShadow: `inset 0 -1px ${theme.palette.divider}`,
  },
  content: {
    flex: 1,
  },
}))
